import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from '../../utils/baseQueryFn';

const tourRateAPI = createApi({
    reducerPath: "tourRateAPI",
    baseQuery,
    endpoints: (builder) => ({
        getTourRateUSDConversion: builder.mutation({
            query: () => ({
                url: `tour-rate-charge/get/usd/rate`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),
        updateTourRateUSDConversion: builder.mutation({
            query: ({ id, rate }) => {
                const queryParams = new URLSearchParams({
                    id,
                    rate
                });

                const apiUrl = `tour-rate-charge/set/usd/rate?${queryParams.toString()}`;

                return {
                    url: apiUrl,
                    method: "PUT",
                };
            },
            transformResponse: (response) => response,
        }),

        getAllTourRateCharges: builder.mutation({
            query: () => ({
                url: `tour-rate-charge/get-list`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),
        createTourRateCharge: builder.mutation({
            query: ({ body }) => ({
                url: `tour-rate-charge/create`,
                method: "POST",
                body
            }),
        }),

        getSharedTourCharges: builder.mutation({
            query: () => ({
                url: `tour-rate-charge/get/shared/charges`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),
        getSharedTourChargeByID: builder.mutation({
            query: ({id}) => ({
                url: `tour-rate-charge/get/shared/charges/${id}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),
        updateSharedTourCharges: builder.mutation({
            query: ({body}) => {
                const apiUrl = `tour-rate-charge/set/shared/charges`;

                return {
                    url: apiUrl,
                    method: "PUT",
                    body
                };
            },
            transformResponse: (response) => response,
        }),

        getMonthlyTourCharges: builder.mutation({
            query: ({month}) => ({
                url: `tour-rate-charge/get-charges/${month}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),
        updateMonthlyTourCharges: builder.mutation({
            query: ({body}) => {
                const apiUrl = `tour-rate-charge/create`;

                return {
                    url: apiUrl,
                    method: "POST",
                    body
                };
            },
            transformResponse: (response) => response,
        }),
        updateBulkTourCharges: builder.mutation({
            query: ({body}) => {
                const apiUrl = `tour-rate-charge/bulk/edit`;

                return {
                    url: apiUrl,
                    method: "POST",
                    body
                };
            },
            transformResponse: (response) => response,
        }),
    }),
});

export const { 
    useGetTourRateUSDConversionMutation,
    useUpdateTourRateUSDConversionMutation,

    useGetAllTourRateChargesMutation,
    useCreateTourRateChargeMutation,

    useGetSharedTourChargesMutation,
    useGetSharedTourChargeByIDMutation,
    useUpdateSharedTourChargesMutation,

    useGetMonthlyTourChargesMutation,
    useUpdateMonthlyTourChargesMutation,
    useUpdateBulkTourChargesMutation
} = tourRateAPI;

export default tourRateAPI;